/**
 * @param {object} props
 * @param {object} props.blok
 */
const StoryblokHeyFlow = ({ blok }) => {
  const { flowID } = blok;

  return <heyflow-wrapper dynamic-height flow-id={flowID} style-config='{"width": "800px"}' />;
};

export default StoryblokHeyFlow;
